import { useApolloClient } from '@apollo/client';
import { MeDocument, type MeQuery } from 'api/core/generated';
import {
  ABBREVIATIONS_BY_LANGUAGES_MAP,
  AppSearchParams,
  LANGUAGES_BY_ABBREVIATIONS_MAP,
} from 'app-constants';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { changeZendeskLocale } from 'services';

export const useCheckUpdateClientUserLanguage = () => {
  const apolloClient = useApolloClient();
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const [isChecked, setIsChecked] = useState(false);

  const checkUpdateClientUserLanguage = useCallback(async () => {
    if (isChecked) {
      return;
    }

    const data: Nullable<MeQuery> = apolloClient.cache.read({
      query: MeDocument,
      optimistic: true,
    });

    const selectedLanguage = i18n.language;

    if (
      searchParams.get(AppSearchParams.language) ||
      !data?.me?.id ||
      !selectedLanguage ||
      !ABBREVIATIONS_BY_LANGUAGES_MAP[selectedLanguage] ||
      !LANGUAGES_BY_ABBREVIATIONS_MAP[data.me.language_abbr] ||
      LANGUAGES_BY_ABBREVIATIONS_MAP[data.me.language_abbr] === selectedLanguage
    ) {
      return;
    }

    const language = LANGUAGES_BY_ABBREVIATIONS_MAP[data.me.language_abbr];

    await i18n.changeLanguage(language);

    changeZendeskLocale(language);

    setIsChecked(true);
  }, [apolloClient, i18n, isChecked, searchParams]);

  return checkUpdateClientUserLanguage;
};
